import React from 'react'
import Players from '../components/Players'

const PlayersPage = () => {
    return <Players />
}

export default PlayersPage
